import {
  CheckoutModuleConfig,
  ClientContext,
} from '../core/ClientContextFactory';
import { PrimerClientError } from '../errors';
import CheckoutStore from '../store/CheckoutStore';
import { AmountChange, CheckoutOptions } from '../types';
import CheckoutTaxCalculator from './tax-calculation/CheckoutTaxCalculator';
import TaxCalculation from './tax-calculation/TaxCalculation';

export interface AmountChangeCallbacks {
  onAmountChange?: (data: AmountChange) => void;
  onAmountChangeError?: (error: PrimerClientError) => void;
  onAmountChanging?: (isChanging: boolean) => void;
}

export const CheckoutModules = {
  create(
    config: CheckoutModuleConfig,
    context: ClientContext,
    store: CheckoutStore,
    options: CheckoutOptions,
  ) {
    if (config.type === 'TAX_CALCULATION') {
      const callbacks: AmountChangeCallbacks = {
        onAmountChange: options.onAmountChange,
        onAmountChangeError: options.onAmountChangeError,
        onAmountChanging: options.onAmountChanging,
      };
      const taxCalculation = new TaxCalculation({
        api: context.api,
        requestUrl: config.requestUrl,
      });
      return new CheckoutTaxCalculator(taxCalculation, store, store, callbacks);
    }
    return null;
  },
};
